import React from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import data from '../assets/data/data-blog'
import { Link } from 'react-router-dom';

BeritaAktiviti.propTypes = {
    
};

function BeritaAktiviti(props) {
    return (
        <div>

            <PageTitle sub='Blog' title='Berita & Aktiviti' />


            <section className="tf-blog">
                <div className="tf-container">
                    <div className="row">
                        {
                            data.map(idx => (
                                <div key={idx.id} className="col-md-6">
                                    <article className="tf-blog-item">
                                        <div className="image">
                                            <Link to="/A-COLLABORATION-TO-EMPOWER-RELIGIOUS-INSTITUTIONS"><img src={idx.img} alt="AlJariyah" /></Link>
                                        </div>
                                        
                                        <div className="title">
                                            <h5><Link to="/A-COLLABORATION-TO-EMPOWER-RELIGIOUS-INSTITUTIONS">{idx.title}</Link></h5>
                                            
                                        </div>
                                        <p className="content">{idx.text}</p>
                                        {/* <Link to="/A-COLLABORATION-TO-EMPOWER-RELIGIOUS-INSTITUTIONS" className="tf-button style-1"><span>{idx.cate}</span></Link> */}
                                        
                                        <div className="meta">
                                            <span className="admin"> <i className="fal fa-user"></i> 
                                                {idx.user}
                                            </span>
                                            <span className="date"><i className="far fa-clock"></i>{idx.time}</span>
                                        </div>
                                    </article>
                                </div>  
                            ))
                        }
                        

                        {/* <div className="col-md-12 ">
                            <div className="load-more">
                                <a className="tf-button loadmore" href="#">Load more</a>
                            </div>
                        </div>                  */}
                        
                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default BeritaAktiviti;